export const TITLE = 'Join Bravado - The World’s Largest Sales Network';
export const DESCRIPTION =
  'Bravado is a community for the world’s top sales professionals. Join the War Room today to become the best with the best';

export const DEFAULT_OG_IMAGE = 'https://bravado-static.s3-us-west-1.amazonaws.com/og_images/default_seo.png';

export const TITLE_FEED = 'The Bravado War Room - The World’s Largest Sales Community';

export const DESCRIPTION_FEED =
  'Account execs, sales development reps, and sales managers can exchange best practices around cold emails, cold calls, demos, closing deals, and quota setting';

export const TITLE_ACADEMY = 'Bravado Academy - Free Advice To Help You Crush Sales';

export const DESCRIPTION_ACADEMY =
  'Learn how to increase your salary, crush your quota, and map out your next career move in sales.';
